(function() {
  "use strict";

  angular.module("PrintixInfoPrinter", [])

    .constant("PrintixPrinterInfoConstants", {
      SHOW: "printer_info_show",
      HIDE: "printer_info_hide"
    })

    .constant("PrintixPrinterInfoSelectors", {
      MODAL_ID: "infoPrinterModal",
      CONFIRM_BUTTON_CSS_CLASS: "confirm-button"
    })


    .controller("InfoPrinterController", ["$rootScope", "$scope", "$location", "URLS", "PRINTER_STATUSES",
      "PrintixPrinterInfoConstants", "USER_RIGHTS", "PrintixPrinterInfoSelectors", "PRINTER_TYPES", "PDLS",
      "TenantListService", "$injector", "$filter", "URL_PARAMS", "NetworkListService",
      function($rootScope, $scope, $location, URLS, PRINTER_STATUSES, PrintixPrinterInfoConstants, USER_RIGHTS,
        PrintixPrinterInfoSelectors, PRINTER_TYPES, PDLS, TenantListService, $injector, $filter, URL_PARAMS, NetworkListService) {

        $scope.printer = null;
        $scope.tenantListService = TenantListService;
        $scope.networkListService = null;
        $scope.printerInfoModalId = PrintixPrinterInfoSelectors.MODAL_ID;
        $scope.USER_RIGHTS = USER_RIGHTS;
        $scope.printerTypes = PRINTER_TYPES;
        $scope.pdls = PDLS;
        $scope.URLS = URLS;
        $scope.URL_PARAMS = URL_PARAMS;
        $scope.printerCurrentNetwork = null;

        try {
          $scope.networkListService = $injector.get("NetworkListService");
        } catch (e) {}

        $scope.getNetworkName = function(printer) {

          if (printer.info._links['px:network']) {
            NetworkListService.getNetworkByUrl(printer.info._links['px:network'].href).then(function(network) {
              $scope.printerCurrentNetwork = network.name;
            }).catch(function(error){});
          } else {
            $scope.printerCurrentNetwork = 'NoNetworkSelected';
          }
        };

        $scope.clearPrinterInfo = function() {
          if ($scope.printer) {
            $scope.printer = null;
          }
        };

        var locationChangeListener = function(){};
        $scope.showPrinterInfo = function(printer) {
          $scope.getNetworkName(printer);
          if (printer) {
            $scope.printer = printer;
            var printModal = angular.element("#" + $scope.printerInfoModalId);
            printModal.modal("show");
            locationChangeListener = $rootScope.$on('$locationChangeStart', function() {
                printModal?.modal("hide");
            })
          } else {
            throw "$scope.showPrinterInfo: printer is missing";
          }
        };

        $scope.openPrinterQueues = function() {
          if (URLS && URLS.PRINTER_PROPERTIES && URL_PARAMS && URL_PARAMS.PRINTER_URL && URL_PARAMS.PRINTER_URL.LOCATION) {
            var url = URLS.PRINTER_PROPERTIES.replace(URL_PARAMS.PRINTER_URL.LOCATION, $scope.printer.customProperties.id);
            $location.path(url).search(URL_PARAMS.SHOW_PRINTER_SECTION.ROUTE, "queues");
          }
        };

        var SHOW_listener = $rootScope.$on(PrintixPrinterInfoConstants.SHOW, function(name, printer) {
          $scope.showPrinterInfo(printer);
        });

        $scope.$on("$destroy", function() {
          SHOW_listener();
          locationChangeListener();
        });
      }
    ])

    .directive("infoPrinterObjectControl", ["$rootScope", "PrintixPrinterInfoSelectors", "PrintixPrinterInfoConstants",
      function($rootScope, PrintixPrinterInfoSelectors, PrintixPrinterInfoConstants) {
        return {
          link: function($scope, element, attrs) {
            element.on("hide.bs.modal", function() {
              $scope.clearPrinterInfo(angular.element(document.activeElement).hasClass(PrintixPrinterInfoSelectors.CONFIRM_BUTTON_CSS_CLASS));
            });
            var HIDE_listener = $rootScope.$on(PrintixPrinterInfoConstants.HIDE, function() {
              element.modal("hide");
            });

            $scope.$on("$destroy", function() {
              HIDE_listener();
            });
          }
        };
      }
    ]);
})();
